export default __webpack_public_path__ + "static/media/32.f386e231.jpeg";